<template>
  <v-navigation-drawer
    v-model="isVisible"
    app
    clipped
    class="admin-nav-drawer"
    :permanent="!_includes(['xs', 'sm'], $mq)"
    color="grey lighten-4"
    :mini-variant="isAdminDrawerMini"
    width="230"
  >
    <v-list dense>
      <v-list-item
        v-for="item in items"
        :key="item.title"
        link
        :to="item.to || ''"
        :href="item.link || ''"
        :target="item.target || 'self'"
        :title="item.title"
        v-tooltip="
          isAdminDrawerMini
            ? getTooltipHtml(!!item.new ? `${item.title} (New!)` : item.title)
            : false
        "
        exact-path
        class="py-1"
      >
        <v-list-item-icon class="mr-4">
          <transition name="fade" mode="out-in">
            <v-badge
              v-if="!!item.new && isAdminDrawerMini"
              bordered
              top
              left
              color="red accent-4"
              dot
              offset-x="5"
              offset-y="5"
            >
            </v-badge>
          </transition>
          <v-icon color="grey darken-2">{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title
            class="proxima-medium--font grey--text text--darken-3"
            >{{ item.title }}
            <v-chip
              v-if="!!item.new"
              x-small
              color="red accent-4"
              class="white--text proxima--font px-2 ml-1"
              >NEW
            </v-chip>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <template v-slot:append>
      <v-list dense>
        <v-list-item :to="{ name: MerchantSupportRoute }" class="py-1">
          <v-list-item-icon
            class="mr-4"
            v-tooltip="
              isAdminDrawerMini ? getTooltipHtml('FAQ & Support') : false
            "
          >
            <v-icon color="grey darken-2">mdi-lifebuoy</v-icon>
          </v-list-item-icon>
          <v-list-item-title
            class="proxima-medium--font grey--text text--darken-3"
            >FAQ &amp; Support</v-list-item-title
          >
        </v-list-item>
        <v-list-item
          @click.prevent="isAdminDrawerMini = !isAdminDrawerMini"
          class="py-1"
        >
          <v-list-item-icon
            class="mr-4"
            v-tooltip="
              isAdminDrawerMini ? getTooltipHtml('Expand Sidebar') : false
            "
          >
            <v-icon>{{
              isAdminDrawerMini
                ? 'mdi-chevron-double-right'
                : 'mdi-chevron-double-left'
            }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="proxima-medium--font"
              >Collapse Sidebar</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import RouteNames from '@/constants/RouteNames'

import _includes from 'lodash/includes'
export default {
  name: 'AdminNavDrawer',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data: () => ({
    MerchantAccountRoute: RouteNames.Merchant.Manage.ACCOUNT,
    MerchantSupportRoute: RouteNames.Merchant.Manage.SUPPORT,
    items: [
      {
        title: 'Dashboard',
        // icon: 'mdi-chart-areaspline',
        icon: 'mdi-chart-line',
        to: { name: RouteNames.Merchant.Manage.DASHBOARD },
        new: false,
      },
      {
        title: 'View Menu',
        icon: 'mdi-storefront-outline',
        to: { name: RouteNames.Guest.MENU },
      },
      {
        title: 'Orders',
        icon: 'mdi-nutrition',
        // icon: 'mdi-food-takeout-box-outline',
        // icon: 'mdi-inbox-arrow-down',
        to: { name: RouteNames.Merchant.Manage.ORDERS },
      },
      {
        title: 'Order Prep',
        icon: 'mdi-progress-check',
        // icon: 'mdi-package-variant',
        // icon: 'mdi-clock-fast',
        // icon: 'mdi-clipboard-edit-outline',
        // icon: 'mdi-chef-hat',
        // icon: 'mdi-check-all',
        // icon: 'mdi-shopping-outline',
        // icon: 'mdi-inbox-arrow-down',
        to: { name: RouteNames.Merchant.Manage.ORDER_PREP },
      },
      {
        title: 'Availability',
        icon: 'mdi-calendar',
        to: { name: RouteNames.Merchant.Manage.AVAILABILITY },
      },
      {
        title: 'Sections',
        icon: 'mdi-format-list-text',
        // icon: 'mdi-view-grid',
        to: { name: RouteNames.Merchant.Manage.SECTIONS },
      },
      {
        title: 'Items',
        icon: 'mdi-table-of-contents',
        to: { name: RouteNames.Merchant.Manage.ITEMS },
      },
      {
        title: 'Rearrange Menu',
        // icon: 'mdi-compare-vertical',
        icon: 'mdi-swap-vertical-bold',
        to: { name: RouteNames.Merchant.Manage.REARRANGE },
      },

      {
        title: 'Customers',
        icon: 'mdi-account-group',
        to: { name: RouteNames.Merchant.Manage.CUSTOMERS },
      },
      {
        title: 'Shop Settings',
        icon: 'mdi-store-cog',
        to: { name: RouteNames.Merchant.Manage.SHOP_SETTINGS },
      },
    ],
  }),
  computed: {
    ...mapGetters('shop', ['getShopTitle']),
    ...mapGetters('auth', ['getAuthUserName', 'getIsAdminDrawerMini']),
    isVisible: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('toggle', val)
      },
    },
    isAdminDrawerMini: {
      get() {
        return this.getIsAdminDrawerMini
      },
      set(is_admin_drawer_mini) {
        this.setIsAdminDrawerMini({ is_admin_drawer_mini })
      },
    },
  },
  methods: {
    ...mapActions('auth', ['setIsAdminDrawerMini']),
    _includes,
    getTooltipHtml(text) {
      return {
        content: `<div class='proxima--font'>${text}</div>`,
        html: true,
        placement: 'right',
        delay: {
          show: 300,
          hide: 0,
        },
      }
    },
  },
}
</script>

<style lang="scss">
.admin-nav-drawer .v-list--dense .v-list-item {
  .v-list-item__title {
    font-size: 0.95rem;
    line-height: 1;
    padding: 9px 0;
  }
  .v-list-item__icon {
    // height: 32px;
    margin-top: 12px;
    margin-bottom: 12px;
  }
}
</style>
